export const baseColorMap = {
  p: {
    textClass: "text-primary-l",
    borderClass: "border-primary",
    lineBgClass: "bg-primary",
    hrBorderClass: "border-primary",
    markBgClass: "bg-primary",
    codeBgClass: "bg-primary",
  },
  s: {
    textClass: "text-secondary",
    borderClass: "border-secondary",
    lineBgClass: "bg-secondary-d",
    hrBorderClass: "border-secondary",
    markBgClass: "bg-secondary-d",
    codeBgClass: "bg-secondary",
  },
};

["red", "orange", "yellow", "lime", "green", "blue", "purple", "pink"].forEach(
  (color) => {
    baseColorMap[color] = {
      textClass: `md-text-${color}`,
      borderClass: `border-${color}`,
      lineBgClass: `bg-${color}`,
      hrBorderClass: `border-${color}`,
      markBgClass: `bg-${color}`,
      codeBgClass: `bg-${color}`,
    };
  }
);

export const getColorConfig = (token) => {
  if (typeof token !== "string") {
    return null;
  }
  const normalized = token.toLowerCase();
  return baseColorMap[normalized] || null;
};

const COLOR_TOKEN_REGEX = /\{\s*([A-Za-z]+)\s*\}\s*$/;

export const extractColorToken = (value = "") => {
  if (typeof value !== "string") {
    return { text: value, token: null };
  }
  const match = value.match(COLOR_TOKEN_REGEX);
  if (!match) {
    return { text: value, token: null };
  }
  const text = value.slice(0, match.index).replace(/\s+$/, "");
  const token = match[1]?.toLowerCase() ?? null;
  return { text, token };
};
